import { PageLoadError } from '@components/page-load-error';
import { getAccountsQueryOptions, getProductsQueryOptions, } from '@features/accounts/api';
import { filterAccountsByType } from '@features/accounts/filterAccountsByType';
import { getProfileQueryOptions } from '@features/user/api';
import { createFileRoute } from '@tanstack/react-router';
import { transferGuard } from './-transfer-guard';

export const Route = createFileRoute(
  '/_authenticated/transfers/high-yield-savings',
)({
  errorComponent: ({ error }) => (
    <PageLoadError
      pageName='Transfer to/from High-Yield Savings'
      error={error}
    />
  ),
  loader: ({ context }) => {
    const profile = context.queryClient.getQueryData(
      getProfileQueryOptions.queryKey,
    );

    const accounts = context.queryClient.getQueryData(
      getAccountsQueryOptions.queryKey,
    );

    const products = context.queryClient.getQueryData(
      getProductsQueryOptions.queryKey,
    );
    const { savingsAccounts } = filterAccountsByType(accounts?.visible);

    transferGuard({
      products: products?.savings,
      accounts: savingsAccounts,
      fundsTransferable: profile?.fundsTransferable,
      hasOptimized: profile?.optimizationSettings.hasOptimized,
      href: `${import.meta.env.VITE_BASE_URL}/transfers/new?source=optimized-savings&target=hub#transfer`,
    });
  },
});
